import { createFileRoute } from "@tanstack/react-router";

import { AccountSettingsSection } from "../components/settings/AccountSettings";
import { SettingsPageContainer } from "../components/settings/settingsLayout";

function SettingsAccountRoute() {
  return (
    <SettingsPageContainer>
      <AccountSettingsSection />
    </SettingsPageContainer>
  );
}

export const Route = createFileRoute("/settings/account")({
  component: SettingsAccountRoute,
});
